import { useEffect, useState } from 'react'

const map = {
    'SYS,DIA,PUL': {
        bg: '#FF993A',
        svg: '#FF7E07',
    },
    'HEIGHT,WEIGHT,BMI': {
        bg: '#369FFF',
        svg: '#006ED3',
    },
    GLU: {
        bg: '#8AC53E',
        svg: '#006838',
    },
    TEMP: {
        bg: '#8AC53E',
        svg: '#FFC000',
    },
    'SMOKE,ALCOLHOL': {
        bg: '#A277FB',
        svg: '#006ED3',
    },
    'SPO2,PUL': {
        bg: '#F582CE',
        svg: '#FD5EBE',
    },
    SALINITY: {
        bg: '#67D0F1',
        svg: '#FD5EBE',
    },
}

export const useRandomColor = () => {
    const color = Object.values(map).map((item) => {
        return { bg: item.bg, svg: item.svg }
    })
    return color[Math.floor(Math.random() * color.length)]
}

export const useTTLBgColor = (name) => {
    const [data, setData] = useState(useRandomColor())
    useEffect(() => {
        if (map[name]) {
            setData(map[name])
        }
    }, [name])
    return data
}
